import proj4 from 'proj4'

//import * as Condition from 'ol/events/condition'
import { defaults as controlDefaults } from 'ol/control'
//import DragZoom from 'ol/interaction/DragZoom'
//import { defaults as interactionDefaults } from 'ol/interaction'
//import LayerGroup from 'ol/layer/Group'
import Map from 'ol/Map'
import { register as registerProj4 } from 'ol/proj/proj4'
import View from 'ol/View'

import ImageLayer from 'ol/layer/Image'
import ImageWMS from 'ol/source/ImageWMS'

import {
  getInteractionByType,
  getLayerByName,
  getLayerGroupByName,
  getScaleFromResolution
} from '../ol-extensions'

//import { ncExtent, jcExtent } from './constants'
import { jcExtent } from './constants'

import 'ol/ol.css'

// from https://epsg.io/2264.js
proj4.defs("EPSG:2264","+proj=lcc +lat_1=36.16666666666666 +lat_2=34.33333333333334 +lat_0=33.75 +lon_0=-79 +x_0=609601.2192024384 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs");
registerProj4(proj4);

//var EPSG2264 = ol.proj.get('EPSG:2264');
//EPSG2264.setExtent(ncExtent);``


// add functions to OpenLayers prototype if needed
if (View.prototype.getScaleFromResolution === undefined) {
  View.prototype.getScaleFromResolution = getScaleFromResolution;
}
if (Map.prototype.getInteractionByType === undefined) {
  Map.prototype.getInteractionByType = getInteractionByType;
}
if (Map.prototype.getLayerByName === undefined) {
  Map.prototype.getLayerByName = getLayerByName;
}
if (Map.prototype.getLayerGroupByName === undefined) {
  Map.prototype.getLayerGroupByName = getLayerGroupByName;
}

const getLayer = (config, defaultOptions) => {
  let layer,
      layerOpts = config.options;

  //console.log(config.name);
  switch (config.type) {
    case 'WMS':
      layer = new ImageLayer({
        text: config.text,
        //type: 'base',
        //visible: config.visible ? config.visible : false,
        layerName: config.name,

        //minResolution: layerOpts.minResolution,
        //maxResolution: layerOpts.maxResolution,

        //extent:    config.extent,  // do not use
        options:   layerOpts,
        source: new ImageWMS({
          //url: WMS_SERVER + config.url,
          url: '' + config.url,
          params: config.params,
          hidpi: false,
          serverType: 'mapserver',
          projection: 'EPSG:2264'
        })
      });
      break;

    default:
      //console.warn('Layer type (' + config.type + ') not handled yet!');
  }
  //console.log(layer);
  config.visible ? layer.setVisible(true) : layer.setVisible(false);
  //console.log(layer.getVisible());
  //console.log(layer);
  return layer;
}

const getInitialMap = (layers) => {
  let extent = jcExtent;

  const width = extent[2] - extent[0];
  const height = extent[3] - extent[1];
  // expand extent
  extent[0] -= width * 0.4;
  extent[2] += width * 0.4;
  extent[1] -= height * 0.4;
  extent[3] += height * 0.4;

  let view = new View({
    projection: 'EPSG:2264',
    extent:     extent,
    center:     [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2,
     ],
     zoom: 0,

     //maxResolution: 222.222222222222,
     //maxResolution: 444.444444444444,
     maxResolution: 888.888888888888,
     minZoom:       0,
     maxZoom:       11,
     zoomFactor:    2,
     enableRotation: false,
  });

  //let controls = [];
  let controls = controlDefaults({
      attribution: false,
      rotate:      false,
      zoom:        false
  });
  //console.log('map.controls *****************');
  //console.log(controls);

/*
  let interactions = interactionDefaults({
      altShiftDragRotate: false,
      pinchRotate:        false,
      shiftDragZoom:      false
  });

  // This is for using pan/zoombox buttons instead of shiftDragZoom
  let dragzoom = new DragZoom({
      condition: Condition.always
  });
  dragzoom.setActive(false);
  interactions.push(dragzoom);
*/

  let olMap = new Map({
    view:         view,
    layers:       [],
    /*controls:     controls,*/
    /*interactions: interactions*/
  });

  //console.log('**** Initial Map defined ******');
  //console.log(olMap);

  //console.log('add layers');
  layers.forEach((layerConfig, i) => {
    const layer = getLayer(layerConfig);
    if (layer) {
        olMap.addLayer(layer);
    }
  });
  //console.log(olMap.getLayers());

  return olMap;
}

export default getInitialMap;
